import type { ReactNode } from 'react';

import type { LayoutHeaderPanelIcon } from './LayoutHeaderPanelIcon';
import { LayoutHeaderPanelRowIcon } from './LayoutHeaderPanelIcon';
import {
  LayoutHeaderPanelRowIconHolder,
  LayoutHeaderPanelRowLabel,
} from './LayoutHeaderPanelRowContent.styled';

type Props = {
  icon: LayoutHeaderPanelIcon;
  title: ReactNode;
};

export function LayoutHeaderPanelRowContent({ icon, title }: Props) {
  return (
    <>
      <LayoutHeaderPanelRowIconHolder aria-hidden>
        <LayoutHeaderPanelRowIcon icon={icon} />
      </LayoutHeaderPanelRowIconHolder>
      <LayoutHeaderPanelRowLabel>{title}</LayoutHeaderPanelRowLabel>
    </>
  );
}
